import { checkNodeCondition } from "./checkNodeCondition";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkSelectedNodesCondition(
  nodeCondition?: NodeCondition | "present",
  maxNodesSelected?: number,
  selectedNodes: NodeModel[] = [],
  selectedRequired?: boolean,
  minNodesSelected?: number,
) {
  if (nodeCondition === undefined) return !selectedRequired;
  if (maxNodesSelected != null && selectedNodes.length > maxNodesSelected) return false;
  if (minNodesSelected != null && selectedNodes.length < minNodesSelected) return false;

  return selectedNodes.some((node) => checkNodeCondition(nodeCondition, node));
}
